import idx from 'idx'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { compose, withHandlers, withStateHandlers, lifecycle, mapProps } from 'recompose'

import * as mapModule from 'modules/map'

import { getBounds } from 'utils/map'
import { HEATMAP_COLORS, ZOOM_MIN, ZOOM_MAX, ZOOM_MIN_DEFAULT } from 'constants/maps'

export default compose(
  connect(
    (state) => {
      return {
        data: idx(state, _ => _.map.data),
        heatmapOpen: idx(state, _ => _.map.heatmap),
        activeTrap: idx(state, _ => _.map.activeTrap),
        activeGroup: idx(state, _ => _.map.activeGroup),
        focusedTrap: idx(state, _ => _.map.focusedTrap),
        focusedGroup: idx(state, _ => _.map.focusedGroup),
        organisation: idx(state, _ => _.organisation.selected)
      }
    },
    (dispatch) => {
      const actions = {
        ...mapModule,
      }
      return {
        actions: bindActionCreators(actions, dispatch),
      }
    },
  ),
  mapProps((props) => {
    return {
      ...props,
      data: {
        ...props.data,
        groupLineDetails: idx(props, _ => _.data.groupLineDetails.filter(item => item.groupUuid === _.activeGroup) || []),
      }
    }
  }),
  withStateHandlers(
    ({ data }) => ({
      tilesLoaded: false,
      heatmapOpen: false,
      mapTypeId: 'satellite',
      loaded: !!data.groupLineDetails,
    }),
    {
      toggleCheckbox: () => event => ({
        rememberMe: event.target.checked
      }),
      onChange: state => changeValues => ({
        ...state,
        ...changeValues
      }),
      setDefaultBounds: () => defaultBounds => ({
        defaultBounds
      }),
      onTilesLoaded: () => () => {
        return {
          loaded: true,
          tilesLoaded: true
        }
      },
      toggleHeatmap: () => value => ({
        heatmapOpen: value
      })
    }
  ),
  withHandlers({
    centerView: () => (map, maps, traps) => {
      const center = getBounds(maps, traps)
      map.fitBounds(center)
    },
  }),
  withHandlers({
    onApiLoad: ({ data, setDefaultBounds }) => (map, maps) => {
      this.map = map
      this.maps = maps
      const bounds = new maps.LatLngBounds()
      data.groupLineDetails.forEach((trap) => {
        bounds.extend({ lat: trap.latitude, lng: trap.longitude })
      })

      setTimeout(() => {
        map.fitBounds(bounds)
      
        maps.event.addListenerOnce(map, 'zoom_changed', () => {
          if (map.getZoom() > ZOOM_MIN_DEFAULT) {
            map.setZoom(ZOOM_MIN_DEFAULT - 2)
          }
        })
        setDefaultBounds(bounds)
      }, 0)
    },
    handleMapZoom: () => (value) => {
      const zoom = this.map.getZoom()
      if (zoom + value < ZOOM_MIN && zoom + value > ZOOM_MAX) {
        this.map.setZoom(zoom + value)
      }
    },
    handleMapReset: ({ defaultBounds, actions }) => () => {
      this.map.fitBounds(defaultBounds)
      actions.resetMapState()
    },
    getMapOptions: ({ mapTypeId }) => () => {
      return {
        mapTypeId,
        scrollwheel: false,
        disableDefaultUI: true,
      }
    },
    handleTrapClick: ({ onChange: setInfoTipState }) => ({ pageX, pageY }, trap) => {
      setInfoTipState({
        infoTipTrap: trap,
        infoTipX: pageX,
        infoTipY: pageY - 446 // height of dashboard header + group header
      })

      if (this.infoTipTimeout) {
        clearTimeout(this.infoTipTimeout)
      }

      this.infoTipTimeout = setTimeout(() => {
        setInfoTipState({ infoTipTrap: null, infoTipX: null, infoTipY: null })
      }, 5000)
    },
    toggleHeatmap: ({ heatmapOpen, data, toggleHeatmap }) => (value) => {
      toggleHeatmap(value)

      const { maps, map } = this

      if (this.heatmap) {
        toggleHeatmap(value)
        this.heatmap.setMap(heatmapOpen ? null : map)
      } else if (data) {
        const gradient = ['rgba(0, 26, 57, 0.55)', ...HEATMAP_COLORS]
        const newHeatMap = new maps.visualization.HeatmapLayer({
          data: data.groupLineDetails.map((point) => {
            return point.totalKills > 0 ? {
              location: new maps.LatLng(point.latitude, point.longitude),
              weight: point.totalKills / 3,
            } : null
          })
        })
        newHeatMap.set('gradient', newHeatMap.get('gradient') ? null : gradient)
        newHeatMap.set('radius', 15)
        newHeatMap.set('maxIntensity', 11)
        newHeatMap.set('dissipating', true)
        newHeatMap.setMap(map)
        this.heatmap = newHeatMap
      }
    }
  }),
  lifecycle({
    componentDidMount() {
      const { data, actions, organisation } = this.props

      if (!data.groupLineDetails || data.groupLineDetails.length === 0) {
        actions.getMapTraps(organisation)
      }
    }
  })
  
)



// WEBPACK FOOTER //
// ./src/components/organisms/GroupTrapMap/GroupTrapMap.enhancer.js